import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partner-add-overview',
  templateUrl: './add-overview.component.html',
  styleUrls: ['./add-overview.component.scss']
})
export class AddPartnerOverviewComponent implements OnInit {
  /**
   * The Type is minimal
   */
  typeminimal = "minimal";
  /**
   * The Type is advanced
   */
  typeadvancted = "advanced";
  /**
   * constructor
   */
  constructor() { }
/**
 * ngOnInit
 */
  ngOnInit(): void {
    
  }
}
